import React from 'react';
import Modal from 'react-modal';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '12px',
        padding: '10px',
        backgroundColor: '#ffffff',
        boxShadow: '2px 4px 20px 5px rgba(155, 154, 154, 0.5)',
        zIndex: 1000
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 999
    }
};

const modalStats = {
    content: {
        top: '50%',
        left: '55%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '12px',
        padding: '10px',
        backgroundColor: '#ffffff',
        boxShadow: '2px 4px 20px 5px rgba(155, 154, 154, 0.5)',
        height: '80%',
        zIndex: 1000
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 999
    }
};

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root')

export default function BaseModel(props) {

    const [modalIsOpen, setIsOpen] = React.useState(true);


    function afterOpenModal() {

    }

    function closeModal() {
        setIsOpen(false);
        props.closeModal();
    }

    return (
        <Modal
            isOpen={modalIsOpen}
            onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            style={props.isStats ? modalStats : customStyles}
            shouldCloseOnOverlayClick={true}
            closeTimeoutMS={2000}
        >
            {props.children}
        </Modal>
    );

}